import type { EmailActivity } from '@common/types/activities';
import { Box, Link, Typography } from '@mui/material';
import ShowLessButton from '../ShowLessButton';
import { cleanHTML } from '../util';

interface Props {
    emailBody: EmailActivity['body'];
    isBodyExpanded: boolean;
    setIsBodyExpanded: (val: boolean) => void;
}

export default function PostIntakeEmailBody({
    emailBody,
    isBodyExpanded,
    setIsBodyExpanded,
}: Props) {
    const submittedByFirstName = emailBody?.SubmittedByFirstName;
    const isPostIntakeEnable = emailBody.IsPostIntakeEnable;
    return (
        <>
            <Box
                sx={{
                    marginTop: '16px',
                    wordWrap: 'break-word',
                    overflowWrap: 'anywhere',
                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        marginBottom: '16px',
                    }}
                >
                    Post intake email
                </Typography>
                <Typography variant="body2" color="text.primary">
                    Hi {emailBody?.ClientFirstName},
                </Typography>
                {submittedByFirstName ? (
                    <>
                        {isPostIntakeEnable && (
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'text.primary',
                                    marginTop: '16px',
                                    overflowWrap: 'break-word',
                                    maxWidth: '900px',
                                }}
                            >
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: cleanHTML(emailBody?.IntakeEmailIntroduction || ''),
                                    }}
                                ></div>
                            </Typography>
                        )}
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.primary',
                                paddingTop: '10px',
                            }}
                        >
                            {submittedByFirstName} has submitted updates to the intake form. If you
                            want to make additional updates, you can do so here:
                        </Typography>
                    </>
                ) : isPostIntakeEnable ? (
                    <>
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.primary',
                                marginTop: '16px',
                                overflowWrap: 'break-word',
                                maxWidth: '900px',
                            }}
                        >
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: cleanHTML(emailBody?.IntakeEmailIntroduction || ''),
                                }}
                            ></div>
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.primary',
                                paddingTop: '10px',
                            }}
                        >
                            If you want to make any updates to your intake form, you can do so here:
                        </Typography>
                    </>
                ) : (
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.primary',
                            paddingTop: '10px',
                        }}
                    >
                        We’ve received your intake form. If you want to make any updates, you can do
                        so here:
                    </Typography>
                )}
                <Link
                    sx={{
                        textDecoration: 'none',
                        fontSize: '14px',
                        lineHeight: '16px',
                        fontWeight: '500',
                        marginTop: '16px',
                        display: 'block',
                        cursor: 'pointer',
                    }}
                    href={emailBody?.IntakeFormLink}
                >
                    Intake form link
                </Link>
                <Box mt={3}>
                    <Typography variant="body2" color="text.primary">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: cleanHTML(emailBody?.EmailSignature || ''),
                            }}
                        ></div>
                    </Typography>
                </Box>
            </Box>
            <Box>
                <ShowLessButton
                    isBodyExpanded={isBodyExpanded}
                    bodyExpandedHandler={setIsBodyExpanded}
                />
            </Box>
        </>
    );
}
